import React from "react";
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Icon, Tooltip } from 'antd'



const AssetMediaData = (props) => {
    const {
        canEditMediaDart,
        changeItemsMedia,
        toggleHover,
        isActive,
        hoverStyle,
        media,
        canDeleteMedia,
        itemSelected,
        showDeleteMedia

    } = props
    return (
        <React.Fragment>
            <div
                
                onMouseEnter={toggleHover}
                onMouseLeave={toggleHover}
                style={
                    isActive
                        ? {
                            background: media.color,
                            border: '1px solid ' + media.color,
                            cursor: (canEditMediaDart) ? 'pointer' : "not-allowed"
                        }
                        : { ...hoverStyle }
                }
            >
                <temp
                    onClick={() => {
                        if (canEditMediaDart)
                            changeItemsMedia(media)
                    }}
                    is="x3d"
                >
                    <Icon
                        type={media.type}
                        style={{
                            fontSize: '20px',
                            width: '25px',
                            marginTop: '6px',
                            marginBottom: '8px',
                            cursor: (canEditMediaDart) ? 'pointer' : "not-allowed",
                        }}
                    />
                    {media.title}
                </temp>
                {canDeleteMedia &&
                    itemSelected.document &&
                    (
                        <span
                            onClick={() =>
                                showDeleteMedia(media._id)
                            }
                        >
                            &times;
                        </span>
                    )}
            </div>

        </React.Fragment>
    )


}

const MAX_LENGTH_MEDIA = 9
const DOTS = "..."
const SLICE_TO = MAX_LENGTH_MEDIA - DOTS.length
class AssetMedia extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isHover: false
        };
    }

    toggleHover = () => {
        this.setState((state) => {
            return {
                ...state,
                isHover: !state.isHover
            };
        });
    };

    render() {
        const { isActive, changeItemsMedia, media, canEditMediaDart, itemSelected, showDeleteMedia, canDeleteMedia, sliceTitle } = this.props
        const { isHover } = this.state
        let hoverStyle = {}
        if (!isActive && isHover) {
            hoverStyle = { ...hoverStyle, backgroundColor: media.color, border: '1px solid ' + media.color, };
        }

        let mediaCopy = { ...media }
        const isSliced = (sliceTitle && media.title && media.title.length > MAX_LENGTH_MEDIA)

        if (isSliced) {
            mediaCopy.title = mediaCopy.title.slice(0, SLICE_TO) + DOTS
        }


        const mediaData = <AssetMediaData
            isActive={isActive}
            changeItemsMedia={changeItemsMedia}
            media={mediaCopy}
            canEditMediaDart={canEditMediaDart}
            itemSelected={itemSelected}
            showDeleteMedia={showDeleteMedia}
            canDeleteMedia={canDeleteMedia}
            hoverStyle={hoverStyle} />
        return (
            <React.Fragment>
                <li>
                    {sliceTitle && isSliced &&
                        <Tooltip title={media.title}>
                            <span></span>
                            {mediaData}
                        </Tooltip>

                    }
                    {(!sliceTitle || !isSliced) &&
                        mediaData

                    }

                </li>
            </React.Fragment >
        )
    }
}

export default injectIntl(
    withRouter(connect(null, null)(AssetMedia))
)
